// @flow

import ActionTypes from 'app/contact-us/ActionTypes';
import reducer from 'app/contact-us/reducer';
import routes from 'app/contact-us/routes';

export default {
  reducers: {
    contact: reducer,
  },
  actionTypes: ActionTypes,
  routes,
};
